<template>
  <div class="article-detail">
    <div class="title t-l f19" style="font-weight:bold;">{{ detail.title ? detail.title : '' }}</div>
    <div class="creater">{{ detail.creater ? detail.creater: ''}}</div>
    <div class="create-time t-l f11 time">{{ detail.created_at ? detail.created_at : ''}}</div>
    <div class="pic">
      <img :src="detail.thumb_url" alt>
    </div>
    <div class="content t-l" v-html="detail.content"></div>
    <template v-if="showHomeTab"><HomeTab /></template>
  </div>
</template>

<script>
import HomeTab from "@/components/HomeTab.vue";
import { getData } from "../Interface/http.js";
export default {
  name: "helpPage",
  data() {
    return {
      showHomeTab: true,
      detail: {}
    }
  },
  mounted() {
    this.$store.commit("UPDATEATBINDEX", { tag: -1 });
     if (this.$route.query.hiddenTab) {
      this.showHomeTab = false;
    }
    this.getDetail();
  },
  methods: {
    getDetail() {
      getData("/article/help").then(res => {
        this.detail = res.data;
      });
    }
  },
  components: {
    HomeTab
  }
};
</script>

<style scoped>
.article-detail {
  padding: 30px 15px 0;
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: #fff;
}
.time {
  margin: 20px 0;
}
</style>
